import React, { useState } from "react";
import "./styles/Contact.css";
import {
  FaMapMarkerAlt,
  FaFacebook,
  FaYoutube,
  FaWhatsapp,
} from "react-icons/fa";

const Contact = () => {
  const [subject, setSubject] = useState("");
  const [customSubject, setCustomSubject] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState("");
  const URL_CORS = process.env.REACT_APP_URL_CORS;

  const handleSubjectChange = (e) => {
    setSubject(e.target.value);
    if (e.target.value === "other") {
      setCustomSubject("");
    }
  };

  const handleCustomSubjectChange = (e) => {
    setCustomSubject(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!subject) {
      setError("Please select a subject.");
      return;
    }
    if (subject === "other" && !customSubject) {
      setError("Please specify your subject.");
      return;
    }

    const payload = {
      email: e.target.email.value,
      subject: subject,
      customSubject: customSubject,
      message: e.target.message.value,
    };

    try {
      const response = await fetch(`${URL_CORS}/send-email`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (response.ok) {
        setIsSubmitted(true);
        setError("");
        e.target.reset();
      } else {
        setError(data.error || "Error sending email.");
      }
    } catch (error) {
      setError("Network error. Try again later.");
      console.error("Error:", error);
    }
  };

  return (
    <main>
      <header className="site-header section-padding-img site-header-image">
        <div className="container">
          <div className="row header-section">
            <div className="col-lg-6 col-12 header-info">
              <h1>
                <span className="d-block" style={{ color: "white" }}>
                Because security is everyone's business
                </span>
              </h1>
            </div>
          </div>
        </div>
      </header>

      <section className="contact">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-12">
              <h2 className="mb-3 pt-5" style={{ color: "#00bf63" }}>
                Go Ahead, Tell Us!
              </h2>
              <p>
                For any inquiries, feel free to reach out to us below. We'll get
                back to you as soon as possible.
              </p>
              <p style={{ fontSize: "0.9rem", color: "#555" }}>
                *In compliance with GDPR, you can exercise your rights to
                access, rectify, and delete your personal data by contacting us
                via email.
              </p>

              {/* Contact form */}
              <form
                className="contact-form me-lg-5 pe-lg-3"
                name="contact"
                method="POST"
                onSubmit={handleSubmit}
              >
                <div className="mb-3">
                  <input
                    type="email"
                    name="email"
                    id="email"
                    className="form-control"
                    placeholder="Email Address"
                    required
                  />
                </div>

                <div className="mb-3">
                  <select
                    name="subject"
                    id="subject"
                    className="form-control"
                    value={subject}
                    onChange={handleSubjectChange}
                    required
                  >
                    <option value="">Choose a Subject</option>
                    <option value="general">General Questions</option>
                    <option value="support">Need Assistance</option>
                    <option value="gdpr">Data Erasure Rights (GDPR)</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                {subject === "other" && (
                  <div className="mb-3">
                    <input
                      type="text"
                      name="customSubject"
                      id="customSubject"
                      className="form-control"
                      placeholder="Specify your subject"
                      value={customSubject}
                      onChange={handleCustomSubjectChange}
                      required
                    />
                  </div>
                )}

                <div className="mb-3">
                  <textarea
                    id="message"
                    name="message"
                    className="form-control"
                    placeholder="Your Message"
                    required
                    style={{ height: "160px" }}
                  />
                </div>

                <div className="col-lg-5 col-6">
                  <button
                    type="submit"
                    className="btn btn-primary form-control"
                  >
                    Send
                  </button>
                </div>
              </form>

              {error && <div className="alert alert-danger mt-3">{error}</div>}

              {isSubmitted && (
                <div className="alert alert-success mt-3">
                  Your message has been successfully sent. We will get back to
                  you as soon as possible.
                </div>
              )}
            </div>

            <div className="col-lg-6 col-12 mt-5 ms-auto">
              <div className="row">
                <div className="col-6 border-end contact-info">
                  <h4 className="mb-3">Follow Us</h4>
                  <ul className="social-icon">
                    <li>
                      <a
                        href="https://facebook.com"
                        className="social-icon-link"
                      >
                        <FaFacebook />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://youtube.com"
                        className="social-icon-link"
                      >
                        <FaYoutube />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://whatsapp.com"
                        className="social-icon-link"
                      >
                        <FaWhatsapp />
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="col-6 border-top border-end contact-info">
                  <h4 className="mb-3">About Us</h4>
                  <p className="text-muted">
                    Learn more about Weekly Cyber and our mission to enhance
                    your digital security.
                  </p>
                </div>

                <div className="col-6 border-top contact-info">
                  <h4 className="mb-3">Our Office</h4>
                  <p className="text-muted">
                    <FaMapMarkerAlt className="me-2" /> Pure Player
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;
